export default __webpack_public_path__ + "static/media/36I-102731_-15804_0.ce0734ea.jpg";